import { useBlogs } from '@/hooks/useBlogs'
import { ProgressSpinner } from '../Common/ProgressSpinner'
import { BlogsGrid } from './BlogsGrid'

export default function Blogs() {
  const { blogs, isLoading, isError } = useBlogs()

  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            From the blog
          </h2>
          <p className="mt-2 text-lg leading-8 text-gray-600">
            Building Excellence: Real Estate Insights & Property Perspectives
          </p>
        </div>

        {isLoading ? (
          <div className="mt-24">
            <ProgressSpinner />
          </div>
        ) : isError ? (
          <div className="mt-10 text-center text-red-600">
            Error loading blogs: {isError.message}
          </div>
        ) : (
          <BlogsGrid blogPosts={blogs} />
        )}
      </div>
    </div>
  )
}
